<template>
  <div>
    <slot :callback="abrirDialog"></slot>

    <SysDialogFullscreen v-model="dialog_ativo">
      <template #titulo>
        <div class="d-flex align-center w-full">
          <v-btn icon class="ml-n2 mr-5" dark @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <div class="d-flex align-center">
            <span>Detalhamento</span>

            <v-divider vertical dark class="mx-2" />

            <div class="font-13">
              {{ map_status_percepcao[props.linha.status_percepcao_key] }}
              <v-icon dark small>mdi-chevron-right</v-icon>
              {{ props.linha.nomemes }}
              de
              {{ props.linha.ano }}
            </div>
          </div>
        </div>
      </template>

      <div class="pl-2 pr-1">
        <sys-data-table
          :height="altura_janela - 163"
          :item-height="45"
          :headers="cabecalhos"
          :items="produtos"
          :search="pesquisa"
        >
          <template #top>
            <div class="d-flex align-center py-3 pr-1 w-full">
              <v-icon size="22" class="mr-1">mdi-format-list-bulleted</v-icon>
              <span class="font-21 font-weight-medium text-systock-blue">Produtos</span>

              <v-divider vertical class="mx-3" />

              <SysBtn @click="exportar()">
                <v-icon left>$Excel</v-icon>
                Exportar
              </SysBtn>

              <v-spacer />

              <div class="w-450">
                <v-text-field
                  v-model="pesquisa"
                  hide-details
                  dense clearable
                  label="Pesquisar"
                  append-icon="mdi-magnify"
                  v-lazy-input:debounce="1000"
                />
              </div>
            </div>
          </template>

          <template #item.idfornecedor="{ item }">
            <span :class="{'text-gray-100': !item.idfornecedor}">{{ item.idfornecedor }}</span>
          </template>

          <template #item.descricao_fornecedor="{ item }">
            <span :class="{'text-gray-100': !item.idfornecedor}">{{ item.descricao_fornecedor }}</span>
          </template>

          <template #item.descricao_produto="{ item }">
            <div class="d-flex align-center">
              <DetalhesProduto
                v-if="!item.produto_eh_categoria_mp_pa"
                :produto="{ id_grupo: item.id_grupo, id_filial: item.filial, id_produto: item.idproduto, produto_eh_combinacao: item.produto_eh_combinacao}"
                ativar_filtro_revenda_direta
              />
              {{ `${item.idproduto} - ${item.descricao_produto}` }}
            </div>
          </template>

          <template #item.ids_solicitacoes_em_aberto="{ item }">
            <PedidosEmTransitoDialog
              v-if="item.ids_solicitacoes_em_aberto.length > 0"
              texto_titulo_dialog="Listagem de pedidos pendentes"
              :produto="{
                id_grupo: item.id_grupo,
                id_produto: item.idproduto,
                produtos: item.produtos,
                nome_produto: item.descricao_produto,
                lista_pedidos_em_aberto: item.ids_solicitacoes_em_aberto,
              }"
              buscar_apenas_pedidos_do_array
            >
              <template #nome-produto>
                {{`${item.idproduto} - ${item.descricao_produto}`}}
              </template>
            </PedidosEmTransitoDialog>
            <p v-else class="ma-0 pr-5 text-center text-gray-100" v-text="'Nenhum'" />
          </template>
        </sys-data-table>
      </div>
    </SysDialogFullscreen>
  </div>
</template>

<script setup>
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import {ref} from "vue";
import api from "@/api/api";
import {formatarParametrosObjParaUrl, logout} from "@/helpers";
import {useHelpers} from "@/components/indicadores/PercepcaoCompras/Grid/Helpers";
import {useResize} from "@/helpers/Resize";
import PedidosEmTransitoDialog from "@/components/dashboard/produtos/PedidosEmTransitoDialog.vue";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import $axios from "@/api/api";

const {altura_janela} = useResize();

const props = defineProps({
  linha: Object,
  filtros_gerais: Object,
});

const {map_status_percepcao} = useHelpers();

const dialog_ativo = ref(false);
const pesquisa = ref('');

function abrirDialog() {
  dialog_ativo.value = true;
  buscarProdutosDetalhamento();
}

const cabecalhos = [
  { text: "Filial", value: "filial" },
  { text: "Ordem Compra", value: "ordem_compra" },
  { text: "Data Solicitação", value: "data_solicitacao" },
  { text: "Id Fornecedor", value: "idfornecedor" },
  { text: "Razão Social", value: "descricao_fornecedor" },
  { text: "Id Produto", value: "idproduto" },
  { text: "Descrição Produto", value: "descricao_produto" },
  { text: "Classificação Financeira", value: "classificacao_financeira" },
  { text: "Unid. Medida", value: "unidade_medida" },
  { text: "Pedidos pendentes", value: "ids_solicitacoes_em_aberto" },
  { text: "Estoque Solicitação", value: "estoque_no_dia_compra", is_number: true },
  { text: "Qtde. do Pedido", value: "qtde_pedido", is_number: true },
];

const produtos = ref([]);

function buscarProdutosDetalhamento() {
  const parametros = {
    ...props.filtros_gerais,
    status_percepcao: props.linha.status_percepcao,
    ano: props.linha.ano,
    mes: props.linha.mes,
  };

  api.post('indicadores/percepcao-compras/produtos-detalhamento', parametros)
    .then(resposta => {
      produtos.value = resposta.data.produtos;
    })
    .catch(logout)
}

function exportar() {
  const url = $axios.defaults.baseURL
    + '/relatorio_produtos_percepcao_compra'
    + formatarParametrosObjParaUrl({
      ...props.filtros_gerais,
      status_percepcao: props.linha.status_percepcao,
      ano: props.linha.ano,
      mes: props.linha.mes,
      id_usuario: localStorage.getItem("id")
    });

  window.open(url, "_blank");
}
</script>
